<template>
  <div class="table-flx">
    <Table stripe :columns="data.columns" :data="data.rows"></Table>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => ({
        columns: [],
        rows: []
      })
    }
  },
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
.table-flx {
  /deep/.ivu-table-wrapper {
    width: 100%;
  }
  /deep/.ivu-table-header thead tr th {
    padding: 12px 0;
  }
}
</style>
